import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const NotFound = () => {

    const isLoggedIn = useSelector(state => state.auth.userToken)

    return (
        <div className="account-pages authentication-bg authentication-bg-pattern d-flex justify-content-center align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-4">
                        <div className="card bg-pattern">
                            <div className="card-body p-4 text-center">
                                <div className="text-error mb-4">404</div>
                                <h4 className="mb-3">Page Not Found</h4>
                                <p className="text-muted mb-4">The page you are looking for does not exist.</p>
                                <Link to={isLoggedIn ? "/dashboard" : "/"} className="btn btn-primary">
                                    Go to { isLoggedIn ? 'Dashboard' : "Home"}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound;